import { useState } from 'react';
import { resolveImageUrl } from '@shared/image.js';
import { addressMapsHref, classifyMediaUrl, mapsHref } from '@shared/mediaUrl.js';
import { YouTubeEmbed } from './YouTubeEmbed.js';
import { LocationButton } from './LocationButton.js';

/**
 * מה שנכתב בעמודת "תמונה" של המשימה, מוצג לפי סוגו: תמונה כתמונה, קישור למיקום ככפתור "פתח מיקום במפות", סרטון כנגן,
 * וכל קישור אחר שאינו תמונה ככפתור קישור — לעולם לא "תמונה שבורה" עם כיתוב.
 * hideMaps: אותו מיקום כבר מוצג בכפתור אחר (למשל זהה לקישור שבטקסט המשימה) — לא מציגים כפתור כפול.
 */
export function MissionMedia({ url, hideMaps = false }: { url: string; hideMaps?: boolean }) {
  const kind = classifyMediaUrl(url);
  const [imageFailed, setImageFailed] = useState(false);

  if (kind === 'none') return null;
  if (kind === 'address') {
    // כתובת / שם מקום שנכתבו בעמודה: מציגים אותם וכפתור שפותח חיפוש שלהם באפליקציית המפות
    return (
      <div className="mission-content__address">
        <span dir="auto">📍 {url.trim()}</span>
        <a className="btn btn--primary" href={addressMapsHref(url)} target="_blank" rel="noopener noreferrer" style={{ alignSelf: 'flex-start' }}>
          <span aria-hidden="true">📍</span> פתח מיקום במפות
        </a>
      </div>
    );
  }
  if (kind === 'maps') {
    const href = mapsHref(url);
    return href && !hideMaps ? <LocationButton url={href} /> : null;
  }
  if (kind === 'youtube') return <YouTubeEmbed url={url} />;

  if ((kind === 'image' || kind === 'unknown') && !imageFailed) {
    return (
      <div className="mission-content__image term-panel">
        <img
          src={resolveImageUrl(url)}
          alt="תמונת המשימה"
          loading="lazy"
          // קישור שאינו תמונה (או תמונה שנמחקה) — מחליפים בכפתור קישור במקום להשאיר אייקון שבור
          onError={() => setImageFailed(true)}
        />
      </div>
    );
  }
  return (
    <a className="btn btn--primary" href={url} target="_blank" rel="noopener noreferrer" style={{ alignSelf: 'flex-start' }}>
      <span aria-hidden="true">🔗</span> פתח את הקישור
    </a>
  );
}
